import { create } from 'axios';
import { getHost } from '../api/api-config';
import type { FrontendConfiguration } from '../api/generated/client';

let appConfiguration: FrontendConfiguration | null = null;

// our default axios only works once the appConfiguration is available. Therefore, we use a separate axios instance
const uninterceptedAxios = create();

async function loadAppConfiguration(): Promise<FrontendConfiguration> {
    const { data } = await uninterceptedAxios.get<FrontendConfiguration>(`${getHost()}/api/configuration/frontend`);

    return data;
}

export async function getAppConfiguration() {
    if (!appConfiguration) appConfiguration = await loadAppConfiguration();

    return appConfiguration;
}
